import React, { useEffect, useMemo, useRef } from "react";
import Downshift from "downshift";
import { useMapboxGeocoder } from "../hooks/useMapboxGeocoder";
import fuzzaldrin from "fuzzaldrin-plus";
import markerSvg from '../img/marker.svg'
import { VenueMarkerIcon } from "./VenueMarkerIcon";
import { venueToCardStyle } from "../utils/venue-style-mapping";

const Search = ({ onSelectPlace, venues, placeholder }) => {
    const [selectedPlace, setSelectedPlace] = React.useState(null);
    useEffect(() => {
        if (onSelectPlace) {
            onSelectPlace(selectedPlace)
        }
    }, [onSelectPlace, selectedPlace]);

    const {
        error,
        isLoading,
        data: mapboxResults,
        fetchMapboxResults,
    } = useMapboxGeocoder();

    const searchString = useRef('')
    const translatedVenues = useMemo(() => {
        return venues.map(v => {
            return {
                ...v,
                id: v.properties._path,
                text: v.properties.title,
                place_name: v.properties.address,
                type: "venue"
            }
        })
    }, [venues]);
    
    const combinedResults = useMemo(() => {
        let results = [];
        if(searchString.current.trim()){
            const fuzzy = fuzzaldrin.filter(translatedVenues, searchString.current, {key: 'text'})
            results.push(...fuzzy);
        }
        results.push(...mapboxResults)
        // console.log({results})
        return results;
    }, [mapboxResults, translatedVenues])

    const handleInputChange = event => {
        if (!event.target.value) {
            return;
        }
        fetchMapboxResults(event.target.value);
        searchString.current = event.target.value;
    };
    const handleDownshiftOnChange = (selectedResult, {clearSelection}) => {
        setSelectedPlace(selectedResult);
        clearSelection()
    };
    return (
        <>
            <Downshift
                onChange={handleDownshiftOnChange}
                itemToString={item => (item ? item.text : "")}
            >
                {({
                    selectedItem,
                    getInputProps,
                    getItemProps,
                    getLabelProps,
                    getMenuProps,
                    getToggleButtonProps,
                    clearSelection,
                    highlightedIndex,
                    isOpen,
                    inputValue,
                }) => {
                    return (
                        <div>
                            <div className="border border-black text-black flex flex-row items-center bg-lightoffwhite paragraph">
                                <i className="fa fa-search px-2"></i>
                                <input
                                    {...getInputProps({
                                        placeholder: placeholder || "Search venue or location",
                                        onChange: handleInputChange,
                                    })}
                                    className="p-2 flex-1 bg-lightoffwhite"
                                //   style={{ width: 175 }}
                                />
                                {selectedItem ? (
                                    <button
                                        className="px-2"
                                        onClick={clearSelection}
                                        aria-label="clear selection"
                                    >
                                        <i className="fa fa-times"></i>
                                    </button>
                                ) : (
                                    null // <button className="px-2" {...getToggleButtonProps()}><i className="fa fa-arrow-right"></i></button>
                                )}
                            </div>
                            {isOpen && (
                                <ul
                                    style={{
                                        padding: 0,
                                        marginTop: 0,
                                        position: "absolute",
                                        // backgroundColor: "white",
                                        width: "100%",
                                        maxHeight: "20rem",
                                        // overflowY: "auto",
                                        // overflowX: "hidden",
                                        // outline: "0",
                                        // transition: "opacity .1s ease",
                                        // borderRadius: "0 0 .28571429rem .28571429rem",
                                        // boxShadow: "0 2px 3px 0 rgba(34,36,38,.15)",
                                        // borderColor: "#96c8da",
                                        // borderTopWidth: "0",
                                        // borderRightWidth: 1,
                                        // borderBottomWidth: 1,
                                        // borderLeftWidth: 1,
                                        // borderStyle: "solid",
                                    }}
                                    className="z-10 bg-lightoffwhite overflow-y-auto overflow-x-hidden shadow border-x border-b border-black text-black"
                                    {...getMenuProps({ isOpen })}
                                >
                                    {isLoading && <div className="p-2" disabled>Loading...</div>}
                                    {error && <div className="p-2" disabled>Error!</div>}
                                    {!isLoading && !error && !combinedResults.length && (
                                        <div className="p-2">No results returned</div>
                                    )}
                                    {inputValue &&
                                        combinedResults.length > 0 &&
                                        combinedResults.slice(0, 10).map((item, index) => (
                                            <div
                                                {...getItemProps({
                                                    key: index,
                                                    index,
                                                    item,
                                                    isActive: highlightedIndex === index,
                                                    isSelected: selectedItem === item,
                                                })}
                                                style={{
                                                    //   backgroundColor:
                                                    //     highlightedIndex === index ? "lightgray" : "white",
                                                    //   fontWeight: selectedItem === item ? "bold" : "normal",
                                                }}
                                                className={`p-2 flex flex-row paragraph ${selectedItem === item ? 'font-bold' : 'font-normal'} ${highlightedIndex === index ? 'bg-stone-300' : ''}`}
                                            >
                                                {item.type === 'venue' && <div className="pr-2">
                                                    <VenueMarkerIcon color={venueToCardStyle(item).backgroundColor} />
                                                </div>}
                                                <div className="flex-1">
                                                    <div className="font-bold">{item.text}</div>
                                                    {item.properties && item.properties.room_name && <div className="small-copy">{item.properties.room_name}</div>}
                                                    <div className="small-copy">{item.place_name}</div>
                                                </div>
                                                
                                            </div>
                                        ))}
                                </ul>
                            )}
                        </div>
                    );
                }}
            </Downshift>
        </>
    );
}

export default Search